import { motion } from 'framer-motion';
import styled from 'styled-components';
import { StyledButton } from '../../../common/Button/styles';

export const Container = styled('div')`
  max-width: 1200px;
  margin: 0 auto;
`;
export const Root = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const HeroImage = styled(motion.img)`
  max-width: 450px;
  margin-bottom: 50px;
  @media only screen and (max-width: 600px) {
    max-width: 330px;
  }
  @media only screen and (max-width: 320px) {
    max-width: 300px;
  }
`;
export const BigButton = styled(StyledButton)`
  font-size: 40px;
  padding: 14px 40px;
  @media only screen and (max-width: 600px) {
    font-size: 20px;
  }
`;
export const RoundButton = styled(StyledButton)`
  border-radius: 50%;
  font-size: 40px;
  border: 3px solid;
  text-align: center;
  height: 100px;
  width: 100px;
  line-height: 1;
  padding: 0;
  letter-spacing: 0;
`;
export const RoundButtonBig = styled(RoundButton)`
  font-size: 27px;
  height: 130px;
  width: 130px;
`;
export const Title = styled('h4')`
  text-shadow: 3px -1px 0px #e02f29;
  font-size: 48px;
  margin-bottom: 0;
  @media only screen and (max-width: 600px) {
    font-size: 36px;
  }
`;
export const SubTitle = styled('p')`
  font-size: 28px;
  text-align: center;
  line-height: 1;
  @media only screen and (max-width: 600px) {
    font-size: 20px;
  }
`;
export const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
  @media only screen and (max-width: 600px) {
    gap: 28px;
  }
`;
// /* Extra small devices (phones, 600px and down) */
// @media only screen and (max-width: 600px) {...}

// /* Small devices (portrait tablets and large phones, 600px and up) */
// @media only screen and (min-width: 600px) {...}

// /* Medium devices (landscape tablets, 768px and up) */
// @media only screen and (min-width: 768px) {...}

// /* Large devices (laptops/desktops, 992px and up) */
// @media only screen and (min-width: 992px) {...}

// /* Extra large devices (large laptops and desktops, 1200px and up) */
// @media only screen and (min-width: 1200px) {...}
